module.exports = __webpack_public_path__ + "img/android-chrome-192x192.fd7f95a9.png";